import React from 'react';

const Confirmation = (params) => {
    const success = () => {
        if (params.data) {
            params.onSuccess(params.data);
        }
        else {
            params.onSuccess();
        }
        params.onClose();
    };

    return (
        <div className="card" style={{ maxWidth: "500px", minWidth: "350px" }}>
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> {params.title ? params.title : "Confirmation"}
            </h5>
            <div className="card-body">
                <div className="ag-theme-alpine">
                    <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                        <div>
                            <div>
                                {params.message}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer text-muted">
                <div style={{ textAlign: "center" }}>
                    {(params.hideAction ? params.hideAction : "false") === "false" ?
                        <button style={{ marginLeft: "5px" }} className="btn btn-secondary" onClick={success} >{params.buttonCaption ? params.buttonCaption : "Confirm"}</button>
                        : ""}
                    <button style={{ marginLeft: "5px" }} className="btn btn-secondary" onClick={params.onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default Confirmation;